import { render } from "./AppearanceView.vue?vue&type=template&id=26b79c90&ts=true"
import script from "./AppearanceView.vue?vue&type=script&lang=ts"
export * from "./AppearanceView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__